import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { motion } from "framer-motion";
const SassMarketingSubscription = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <section className="mk-subscribe bg-white overflow-hidden ptb-60" >
      <div className="container">
        <div className="mk-subscribe-box position-relative rounded bg-light-subtle">
          <img
            src="assets/img/shape/sb-wave-top.png"
            alt="wave shape"
            className="position-absolute sb-shape end-50 top-0"
          />
          <img
            src="assets/img/shape/sb-circle-half.png"
            alt="circle"
            className="position-absolute sb-shape end-0 bottom-0"
          />
          <div className="row">
            <div className="col-xl-6">
              <div className="mk-box-content">
                <div className="mk-title">
                  <span className="mk-subtitle mb-3">Let&apos;s Try!</span>
                  <h2 className="mk-heading mb-3">
                    Start your 15-Day free trial
                  </h2>
                  <p className="mb-0">
                    Unlock the full potential of your garage with our all-in-one
                    software. Try every feature, boost efficiency, and
                    experience real results; all free for 15 days, no credit
                    card needed.
                  </p>
                </div>
                <form className="mk-sb-form d-flex align-items-center mt-40 flex-wrap flex-sm-nowrap">
                  {/* <input type="email" placeholder="Enter your Email" /> */}
                  <Button type="button"
                    className="mk-submit-btn mt-sm-0"
                    onClick={handleShow}>
                    Get Started
                  </Button>
                </form>
                <div className="sb-meta-text d-flex align-items-center mt-4 flex-wrap">
                  <span>
                    <span className="dot me-1"></span>Free 15 Days trial
                  </span>
                  <span>
                    <span className="dot me-1"></span>No Credit Card Required
                  </span>
                  <span>
                    <span className="dot me-1"></span>Cancel anytime
                  </span>
                </div>
              </div>
            </div>
          </div>
          <img
            src="assets/img/marketing/sb-object.png"
            alt="object"
            className="position-absolute sb-object d-none d-lg-block"
          />
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered backdrop="static" animation={false}>
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: -50 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: -50 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>✨ Free Trial</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            For free trial you need to register with us.
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              as="a"
              href="http://wms.senertech.in/register"
              target="_blank"
              rel="noopener noreferrer"
              variant="primary"
            >
              Register
            </Button>

          </Modal.Footer>
        </motion.div>
      </Modal>
    </section>

  );
};

export default SassMarketingSubscription;
